import { LOCAL_CONSTANT } from "../../Const";
import { getStaffNoList } from "../../mailFunction";

export const settingMailDetailParam = (params: any) => {
    const staffMasterObj = localStorage.getItem("staffMaster");
    let staffNoList: any = [];
    let mailDetailParam: any = null;
    if (
        (params.taskId === "D002" && params.selectData.taskId === "D004") ||
        (params.taskId === "D006" && params.selectData.taskId === "D007")
    ) {
        if (params.taskId === "D002") {
            if (staffMasterObj !== null) {
                staffNoList = getStaffNoList(
                    "requestEmail_5mOutsideMarketCut_D002",
                    {
                        staffMasterObj: staffMasterObj,
                        userData: params.userData,
                    }
                );
            }
        } else {
            staffNoList = getStaffNoList(
                "requestEmail_5mOutsideMarketCut_D006",
                {
                    planAreaInfoData: params.planAreaInfoData,
                    userData: params.userData,
                }
            );
            // proxy_approval_user_rmに値がある場合は追加
            if (params.locationBaseData?.proxy_approval_user_rm) {
                staffNoList.push(params.locationBaseData.proxy_approval_user_rm);
            }
        }
        // 操作ユーザー追加
        staffNoList.push(params.userData.staff_number);
        let titleDetail = "";
        if (
            params.traffic5mcut.cut_survey === "1" &&
            params.marketCut.cut_market === "1"
        ) {
            titleDetail = LOCAL_CONSTANT.LABEL.location5mCutMarketCutApproval;
        } else if (params.traffic5mcut.cut_survey === "1") {
            titleDetail = LOCAL_CONSTANT.LABEL.location5mCutApproval;
        } else if (params.marketCut.cut_market === "1") {
            titleDetail = LOCAL_CONSTANT.LABEL.marketCutApproval;
        }
        mailDetailParam = {
            survey_name: params.cover.survey_name,
            titleDetail: titleDetail,
            url: `${process.env.REACT_APP_HOST}/approval-5mcut?${params.encryptedQueryParam}`,
            rfc: params.cover.survey_creator,
            confirmationPerson: params.userData.user_name,
            staffNoList: staffNoList,
            plan_area_id: params.planAreaId,
            branch: params.branch,
            type: "01",
            notficationType: "01",
        };
    } else if (
        (params.taskId === "E004" && params.selectData.taskId === "E010") ||
        (params.taskId === "E007" && params.selectData.taskId === "E010") ||
        (params.taskId === "E005" && params.selectData.taskId === "E010")
    ) {
        // 追加調査メール処理
        const staffMasterObj = localStorage.getItem("staffMaster");
        let staffNoList: any = getStaffNoList("requestCommentAddSurvey", {
            staffMasterObj: staffMasterObj,
            userData: params.userData,
        });
        // proxy_approval_user_rmに値がある場合は追加
        if (params.locationBaseData?.proxy_approval_user_rm) {
            staffNoList.push(params.locationBaseData.proxy_approval_user_rm);
        }

        let titleDetail = "";
        mailDetailParam = {
            survey_name: params.cover.survey_name,
            titleDetail: titleDetail,
            url: `${process.env.REACT_APP_HOST}/approval-survey?${params.encryptedQueryParam}`,
            rfc: params.cover.survey_creator,
            staff_name: params.userData.user_name,
            confirmationPerson: params.userData.user_name,
            staffNoList: staffNoList,
            plan_area_id: params.planAreaId,
            branch: params.branch,
            type: "01",
            notficationType: "01",
        };
    } else if (
        (params.taskId === "E008" && params.selectData.taskId === "E011") ||
        (params.taskId === "E006" && params.selectData.taskId === "E011")
    ) {
        // 追加調査メール処理
        const staffMasterObj = localStorage.getItem("staffMaster");
        let staffNoList: any = getStaffNoList("requestCommentAddSurvey", {
            staffMasterObj: staffMasterObj,
            userData: params.userData,
        });
        // proxy_approval_user_rmに値がある場合は追加
        if (params.locationBaseData?.proxy_approval_user_rm) {
            staffNoList.push(params.locationBaseData.proxy_approval_user_rm);
        }

        let titleDetail = "";
        mailDetailParam = {
            survey_name: params.cover.survey_name,
            titleDetail: titleDetail,
            url: `${process.env.REACT_APP_HOST}/approval-survey?${params.encryptedQueryParam}`,
            rfc: params.cover.survey_creator,
            staff_name: params.userData.user_name,
            confirmationPerson: params.userData.user_name,
            staffNoList: staffNoList,
            plan_area_id: params.planAreaId,
            branch: params.branch,
            type: "01",
            notficationType: "01",
        };
    }

    return mailDetailParam;
};
